// @ts-strict-ignore
import { Box3, Group, Mesh, Object3D, Vector3 } from 'three';
import { FaceUtils } from '@3d-scene/common/util/face-utils';
import { Face3D } from '@3d-scene/model/face-3d';
import { IsThreeJsType } from './is-threejs-type';

export class MetricUtils {

  public static getRealSize(object: Group, excludedNames: string[] = null): Vector3 {
    const min: Vector3 = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    const max: Vector3 = new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    this.findMixMaxRecursevly(object, min, max, false, excludedNames);
    return new Vector3(max.x - min.x, max.y - min.y, max.z - min.z);
  }

  public static findMixMaxRecursevly(obj: Object3D, minPoint: Vector3, maxPoint: Vector3, inGlobal: boolean = false,
                                     excludedNames: string[] = null, targetContainer: Object3D = null): void {
    if ((IsThreeJsType.mesh(obj)) && (!excludedNames || excludedNames.indexOf(obj.name) === -1)) {
      FaceUtils.findMinMaxForMesh(obj as Mesh, minPoint, maxPoint, inGlobal, targetContainer);
    }

    if ((obj instanceof Object3D)) {
      for (const child of obj.children) {
        this.findMixMaxRecursevly(child, minPoint, maxPoint, inGlobal, excludedNames, targetContainer);
      }
    }
  }

  public static createBoundsRecursively(obj: Object3D, inGlobal: boolean = true, excludedNames: string[] = null, targetContainer: Object3D = null): Box3 {
    const min: Vector3 = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    const max: Vector3 = new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);

    MetricUtils.findMixMaxRecursevly(obj, min, max, inGlobal, excludedNames, targetContainer);

    return new Box3(min, max);
  }

  public static findMinMaxForFaces(faces: Face3D[],
                                   minPoint: Vector3, maxPoint: Vector3): void {
    for (const face of faces) {
      for (const vertex of face.vertices) {
        if (maxPoint.x < vertex.x) {
          maxPoint.x = vertex.x;
        }
        if (maxPoint.y < vertex.y) {
          maxPoint.y = vertex.y;
        }
        if (maxPoint.z < vertex.z) {
          maxPoint.z = vertex.z;
        }
        if (minPoint.x > vertex.x) {
          minPoint.x = vertex.x;
        }
        if (minPoint.y > vertex.y) {
          minPoint.y = vertex.y;
        }
        if (minPoint.z > vertex.z) {
          minPoint.z = vertex.z;
        }
      }
    }
  }

  public static getMiddlePoint(object: Object3D): Vector3 {
    const min: Vector3 = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    const max: Vector3 = new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    this.findMixMaxRecursevly(object, min, max);
    return new Vector3((min.x + max.x) / 2, (min.y + max.y) / 2, (min.z + max.z) / 2);
  }
}
